import React from "react";
import ResetPasswordForm from "./resetPasswordForm";
import Form from "../../components/formWrapper/FormWrapper";
import * as Yup from "yup";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import "./resetPasswordBox.scss";
import lanetalkLogo from "../../../shared/images/logo192.png";

const initValues = {
  newPassword: "",
  newPasswordConfirm: "",
};

const ResetPassword = () => {
  const renderComponent = (props) => {
    return <ResetPasswordForm {...props} />;
  };

  return (
    <div className="loginPage">
      <div className="joinOurCommunitySection">
        <img width="auto" height="auto" src={lanetalkLogo} alt="" />
        <span className="textLogo">Lanetalk</span>
      </div>
      <div className="loginSection">
        <div className={"loginBoxClassName" || ""}>
          <h3
            className={themeStyles.headerSmInverted}
            style={{ marginBottom: "3em" }}
          >
            Reset Password
          </h3>
          <Form
            initialValues={initValues}
            component={renderComponent}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              newPassword: Yup.string()
                .required("No password provided.")
                .min(7, "Password is too short - should be 8 chars minimum"),
              newPasswordConfirm: Yup.string()
                .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
                .required("No password provided."),
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
